import { createServiceStateApi } from './_serviceState';
const api = createServiceStateApi('customerrisk');
export const { getAllState, getState, patchState, putState, removeState } = api;
export default api;
